import {NavList, Spinner} from '@primer/react'

import type {StackSectionEntryType} from '../../../helpers/merge-box-status-calculator/stack-section-status'
import {MergeSectionActions} from './MergeSectionActions'
import {MergeBoxSectionHeader} from '../common/MergeBoxSectionHeader'
import {EntryStatusIcon} from '../stack-section/EntryStatusIcon'

export function StackMergeInProgress({entries}: {entries: StackSectionEntryType[]}) {
  return (
    <MergeSectionActions>
      <MergeSectionActions.Slot>
        <div className="flex-1">
          <MergeBoxSectionHeader title={'Stack is merging...'} icon={<Spinner size="small" className="mt-1" />} />
          <NavList aria-label="Pull requests in this stack">
            {entries.map(e => {
              if (e.position === 'AFTER') return null
              return (
                <NavList.Item key={e.pull.number} href={e.pull.url} aria-current={e.position === 'CURRENT'}>
                  <NavList.LeadingVisual>
                    <EntryStatusIcon entry={e} rebaseState={'SUCCEEDED'} />
                  </NavList.LeadingVisual>
                  <span>{e.pull.title}</span> <span className="fgColor-muted">#{e.pull.number}</span>
                </NavList.Item>
              )
            })}
          </NavList>
        </div>
      </MergeSectionActions.Slot>
    </MergeSectionActions>
  )
}
